import { render, staticRenderFns } from "./Comentario.vue?vue&type=template&id=1bace6f1&scoped=true&"
import script from "./Comentario.vue?vue&type=script&lang=js&"
export * from "./Comentario.vue?vue&type=script&lang=js&"
import style0 from "./Comentario.vue?vue&type=style&index=0&id=1bace6f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bace6f1",
  null
  
)

export default component.exports